import { Heading } from '@altify/components';
import { useContent } from '@altify/utils';
import { useEffect } from 'react';
import { View } from 'react-native';
import { content } from './TaxInformationSuccessModal.content';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import CheckMarkIcon from '../../assets/CheckMark.svg';
const TaxInformationSuccessModal = ({
  isOpen,
  isUpdate,
  onClose,
}: {
  isOpen: boolean;
  isUpdate: boolean;
  onClose: () => void;
}) => {
  const localizedContent = useContent(content);
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer); // Cleanup the timer on unmount or when `visible` changes
    }
  }, [isOpen]);
  return (
    <DialogOrBottomSheet
      blurEnabled={true}
      isOpen={isOpen}
      dismissable={false}
      backgroundColor="#0C1C2C">
      <View className="w-full flex flex-col items-center gap-4 px-8 gap-8 my-20">
        <img height={100} width={100} src={CheckMarkIcon} alt="Success" />
        <Heading level={3} className="text-center">
          {isUpdate ? localizedContent.title : localizedContent.submittedTitle}
        </Heading>
      </View>
    </DialogOrBottomSheet>
  );
};

export default TaxInformationSuccessModal;
